import { Link } from "react-router-dom";
import { format } from "date-fns";

import post1 from "../assets/post1.png";
// thêm nếu có post2, post3...

const imageMap = {
  post1: post1,
  // post2: post2,
};

function CardPost({ post }) {
  const postUrl = `/tin-tuc/${post.slug}`;

  const formattedDate = post.created_at
    ? format(new Date(post.created_at), "dd/MM/yyyy")
    : "";

  const imageSrc = imageMap[post.image] || "/placeholder.jpg";

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300 overflow-hidden group relative">
      <Link to={postUrl} className="block h-full">
        <div className="overflow-hidden">
          <img
            src={imageSrc}
            alt={post.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </div>

        <div className="p-4 flex flex-col justify-between h-[calc(100%-12rem)]">
          <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition mb-2">
            {post.title}
          </h3>

          <div className="text-sm text-gray-500 absolute bottom-2 right-3">
            {formattedDate}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default CardPost;